import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import "./NewLoanModal.scss";
import handleChange from "../../hooks/handleChange";

function NewLoanModal({ open, handleClose, selectedUserData }) {
  const [searchInput, setSearchText, resetSearchInput] = handleChange();
  const [startDate, setStartDate] = useState(getFormattedDate(new Date()));

  function getFormattedDate(date) {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0"); // months are zero-based
    let day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="loan-entry-container"
        style={{
          position: "fixed",
          //   transform: "translate(116px, 96px)",
          zIndex: 9999,
          display: "flex",
          //   alignItems: "center",
          //   justifyContent: "center",
          //   width: "80%",
        }}
      >
        <div className="centered-content">
          {/* <div className="text-end pointer">
            <img src={Close} onClick={handleClose} />
          </div> */}
          <h4>New Loan Type</h4>
          {/* <div>
            <iframe
              src="https://dev-portal.4pay.ca/testiframe.html"
              width="100%"
              height="500px"
              style={{ border: "none" }}
              title="External Content"
            ></iframe>
          </div> */}
          <div className="post-entry-form-container container">
            <div className="row justify-content-around">
              <div className="col-12">
                <label for="loan">Loan Type:</label>
                <input
                  name="loan"
                  id="loan"
                  type="text"
                  value={searchInput}
                  onChange={setSearchText}
                  placeholder="Loan Type"
                />
              </div>
            </div>
            <div className="post-entry-account-containers">
              <label for="start">Start date:</label>

              <input
                type="date"
                id="start"
                name="trip-start"
                value={startDate}
                min={getFormattedDate(new Date())}
                onChange={(e) => setStartDate(e.target.value)}
              />
              <div className="d-flex justify-content-end">
                <div className="post-entry-confirm mt-4">Create Loan Type</div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default NewLoanModal;
